// extracted by mini-css-extract-plugin
export default {"container":"Qk-z","bubbleNav":"Rk-z","graphic":"Sk-z","contact":"Tk-z"};